import * as React from "react";
import { ModalService3 } from "modal-service-3/modal-service-3";
import {cx} from "emotion";

import "./images-modal.scss";

import {cs}       from "@Common/react/chain-services";
import {keyed}    from "@Common/react/keyed";
import {scnv}     from "@Common/react/state-change-nested-value";
import {UseState} from "@Common/react/use-state";

import {InformationBadge} from "../../../../../../common/design2/information-badge/information-badge";
import {Radio}            from "../../../../../../common/design2/radio/radio";

export const ImagesModal = ({images, current, next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        title: (
            <div className="images-modal-8gk title">
                Ride Along Image

                {InformationBadge({
                    getTooltip: () => "A clickable call to action. Appears in color beneath the image of your mailpiece.",
                    height: 14,
                })}
            </div>
        ),
        width: 846,
        top: 100,
        next,
        rootNext,
    })],
    ["current", (_, next) => UseState({
        initValue: current,
        next,
    })],
    ({modal, current}) => (
        <div className="images-modal-8gk content">
            <div className="images">
                {images?.map(({url}, index) => cs(
                    keyed(url),
                    () => {
                        const selected = current.value === url;
                        return (
                            <div {...{
                                className: cx("image", {selected}),
                                onClick: () => {
                                    scnv(current, [], () => url);
                                },
                                "xd-qa-type": "card",
                                "xd-qa-name": "Ride Along Image #" + (index+1),
                            }}>
                                {Radio({
                                    selected,
                                    size: "small",
                                    xdQaName: "Ride Along Image Radio",
                                })}

                                <div className="img">
                                    <img {...{
                                        src: url,

                                        "xd-qa-type": "image",
                                        "xd-qa-name": "Ride Along Image Thumbnail",
                                    }}/>
                                </div>
                            </div>
                        );
                    },
                ))}
            </div>

            <div className="footer">
                <button {...{
                    className: "next",
                    onClick: () => {
                        modal.params.onDone(current.value);
                        modal.close();
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "Use this image",
                }}>
                    Use this image
                </button>
            </div>
        </div>
    ),
);
